import { ComponentType, type IConfig } from '../../types';
import { config as linkConfig } from '../link/config';

export const config: IConfig = {
  ...linkConfig,
  component: ComponentType.FormLink,
};
